// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_jl-0";
export var animationContainer = "_jl-1";
export var itemPrice = "_jl-a";
export var itemizedContent = "_jl-9";
export var itemizedHeader = "_jl-7";
export var itemizedRow = "_jl-8";
export var itemizedSection = "_jl-6";
export var modalContent = "_jl-2";
export var orderName = "_jl-3";
export var refundOption = "_jl-4";
export var refundOptionsContainer = "_jl-5";
export var shippingLabel = "_jl-b";
export var totalRow = "_jl-c";